// extracted by mini-css-extract-plugin
export default {"main":"brand-info_main__TADVG","info-block":"brand-info_info-block__icceN","header-content":"brand-info_header-content__tcBjP","body-content":"brand-info_body-content__XBoMh"};